export default __webpack_public_path__ + "static/media/layers.89c20cf3.png";